import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import './Header.scss';
import HeaderCanvas from './HeaderCanvas';
import UserHeaderCanvas from './UserHeaderCanvas';

interface CustomProps {
  headerType?: 'logged-in' | 'pre-login';
  active?: boolean;
}

const Header: React.FC<CustomProps> = ({ headerType, active }) => {
  const [headerData, setHeaderData] = useState<any>(null);

  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/header?populate[0]=logo&populate[1]=navigation.subNavItem`
        );
        setHeaderData(response?.data?.data);
      } catch (error) {
        toastr.error('Failed to fetch header data', '');
      }
    };
    fetchHeaderData();
  }, []);

  return (
    <HeaderCanvas
      active={active}
      data={headerData}
      loggedIn={headerType === 'logged-in'}
    />
  );
  // return headerType !== 'logged-in' ? (
  //   <HeaderCanvas active={active} data={headerData} />
  // ) : (
  //   <UserHeaderCanvas />
  // );
};

export default Header;
